import { observer } from 'mobx-react';
import { FormikErrors } from 'formik';

import ForwardModalForm from '@/forwarding/components/ForwardModal/ForwardModalHeader/ForwardModalForm/ForwardModalForm';
import ForwardPreview from '@/forwarding/components/ForwardPreview/ForwardPreview';
import ForwardPreviewHeader from '@/forwarding/components/ForwardPreviewHeader/ForwardPreviewHeader';
import { useForwardPreviewMediaSize } from '@/forwarding/hooks/useForwardPreviewMediaSize';
import { ForwardForm } from '@/forwarding/types/ForwardForm';
import { ForwardPreviewData } from '@/forwarding/types/ForwardPreviewData';

import styles from './ForwardModalHeader.module.css';

export interface ForwardModalHeaderProps {
  preview: Nullable<ForwardPreviewData>;
  values: ForwardForm;
  errors: FormikErrors<ForwardForm>;
  readOnly?: boolean;
  isTitleReadOnly?: boolean;
  setFieldValue: <T extends keyof ForwardForm>(key: T, val: ForwardForm[T]) => void;
}

function ForwardModalHeader(props: ForwardModalHeaderProps) {
  const { preview, values, errors, readOnly, isTitleReadOnly = false, setFieldValue } = props;

  const mediaSize = useForwardPreviewMediaSize();

  if (!preview) {
    return null;
  }

  if (readOnly) {
    return (
      <ForwardPreviewHeader preview={preview} title={values.title} description={values.description} isVertical />
    );
  }

  return (
    <div className={styles.forwardModalHeader}>
      <ForwardPreview preview={preview} mediaSize={mediaSize} />

      <ForwardModalForm
        className={styles.form}
        values={values}
        setFieldValue={setFieldValue}
        errors={errors}
        isTitleReadOnly={isTitleReadOnly}
      />
    </div>
  );
}

export default observer(ForwardModalHeader);
